<template>
  <li v-if="info.routeCode === ROUTES.CODE.INSPIRATION && auth.idSupplier">
    <button
      :class="[ 'flex items-center w-full pb-4 text-start outline-none font-bold focus:outline-none focus:ring-0 hover:no-underline', idSupplier ? (isDetail ? 'text-selected-detail focus:text-selected-detail' : 'text-selected-item focus:text-selected-item') : (isDetail ? 'text-bolder' : 'text-heading'), className ? className : 'text-base' ]"
      @click="handleClick"
    >
      <span>{{ $t(info.label) }}</span>
    </button>
  </li>
</template>

<script setup>
import { ROUTES } from "@utils/routes";
import { useUIStore } from '@stores/ui';
import { useAuthStore } from '@stores/auth';

defineProps({
  className: {
    type: String,
    default: () => ''
  },
  isDetail: {
    type: Boolean,
    default: false
  }
});

const ui = useUIStore();
const { $eventBus } = useNuxtApp();
const route = useRoute();
const auth = useAuthStore();

const idSupplier = computed(() => +route.query.idSupplier);

const routeName = computed(() => route?.name || '');

const info = computed(() => {
  if (routeName.value.startsWith('offers___') || routeName.value.startsWith('offers-slug___')) {
    return { label: 'text-my-offers', routeCode: ROUTES.CODE.OFFERS };
  } else if (routeName.value.startsWith('requests___') || routeName.value.startsWith('requests-slug___')) {
    return { label: 'text-my-requests', routeCode: ROUTES.CODE.REQUESTS };
  } else if (routeName.value.startsWith('auctions___') || routeName.value.startsWith('auctions-slug___')) {
    return { label: 'text-my-auctions', routeCode: ROUTES.CODE.AUCTIONS };
  } else if (routeName.value.startsWith('inspiration___') || routeName.value.startsWith('inspiration-type-slug___')) {
    return { label: 'text-my-inspiration', routeCode: ROUTES.CODE.INSPIRATION };
  } else if (routeName.value.startsWith('favorites___')) {
    return { label: 'text-my-favorites', routeCode: ROUTES.CODE.FAVORITES };
  } else if (routeName.value.startsWith('search___')) {
    return { label: 'text-my-favorites', routeCode: ROUTES.CODE.SEARCH };
  } else {
    return { label: 'text-my-ads', routeCode: ROUTES.CODE.ADS };
  }
});

const closeSidebar = () => {
    $eventBus.emit('sidebar:close');
};

const handleClick = async () => {
  const params = { ...route.query };
  if (!params.idSupplier) params.idSupplier = auth.idSupplier; else delete params.idSupplier;
  await navigatorTo({
    path: translatePath(info.value.routeCode),
    query: params,
  })
  if (ui.displaySidebar) {
    closeSidebar();
  }
}

</script>
